import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.services": "Services",
      "nav.about": "About",
      "nav.offers": "Offers",
      "nav.testimonials": "Testimonials",
      "nav.blog": "Blog",
      "nav.contact": "Contact",
      "nav.requestQuote": "Request Quote",
      "nav.whatsapp": "WhatsApp Us",
      "nav.getQuote": "Get a Quote",
      "nav.rasAlKhor": "Visit Ras Al Khor Garage",
      "nav.rasAlKhorShort": "Ras Al Khor",
      "nav.chatWhatsApp": "Chat on WhatsApp",
      
      // Hero Section
      "hero.title.main": "Dubai's Premium Garage for Every Car",
      "hero.title.sub": "Affordable & Reliable",
      "hero.subtitle": "Expert car service in Ras Al Khor serving European, Japanese, Korean & American vehicles with certified technicians",
      "hero.cta.quote": "Request A Quote",
      "hero.cta.whatsapp": "WhatsApp Us",
      
      // Offers Cards
      "offers.diagnostics": "Free Computer Diagnostics",
      "offers.oilChange": "Oil Change + Free Items",
      "offers.pickup": "Free Pickup and Dropoff",
      "offers.brands": "All Major Brands Serviced",
      
      // Free Inspection
      "inspection.badge": "Limited Time",
      "inspection.title": "Free Comprehensive Car Inspection in Ras Al Khor",
      "inspection.description": "Get a no-cost multi-point inspection at our Ras Al Khor car garage covering brakes, belts, spark plugs, cooling / radiator water level, brake fluid level, AC filter cleaning & system health snapshot. Perfect for Dubai drivers before seasonal change or long-distance travel.",
      "inspection.cta.book": "Book Free Inspection",
      "inspection.cta.offers": "View All Offers",
      "inspection.items.brake": "Brake Pad Check",
      "inspection.items.belt": "Belt & Drive Visual",
      "inspection.items.spark": "Spark Plug Condition",
      "inspection.items.radiator": "Radiator Water Top-Up",
      "inspection.items.brakeFluid": "Brake Fluid Level",
      "inspection.items.acFilter": "AC Filter Clean",
      
      // Services Section
      "services.title": "Comprehensive Car Services in Ras Al Khor Dubai",
      "services.subtitle": "From routine maintenance to complex system diagnostics and repairs, our certified technicians at our Ras Al Khor car garage provide dealership-quality service with the care and transparency of an independent workshop.",
      
      // Why Choose Us
      "whyChoose.title": "Why Choose Vigor Auto?",
      "whyChoose.expertise": "15+ Years Expertise",
      "whyChoose.expertise.desc": "Seasoned technicians leveraging OEM data + modern diagnostics",
      "whyChoose.turnaround": "Rapid Turnaround",
      "whyChoose.turnaround.desc": "Streamlined workflow + accurate first-pass diagnostics reduce downtime",
      "whyChoose.transparent": "Transparent Estimates",
      "whyChoose.transparent.desc": "Fair pricing logic aligned with labor guides & MSRP references",
      "whyChoose.quality": "Quality Parts",
      "whyChoose.quality.desc": "OEM / Tier-1 components for reliability, longevity & performance integrity",
      
      // Vehicle Origins
      "origins.title": "We Service Every Heritage",
      "origins.subtitle": "From meticulous Japanese platforms to torque-rich American builds, advanced Korean innovation, and precision European engineering—our multidisciplinary team supports them all.",
      "origins.japanese": "Japanese Cars",
      "origins.japanese.reliability": "Reliability",
      "origins.japanese.engineering": "Refined engineering",
      "origins.japanese.performance": "Balanced performance",
      "origins.korean": "Korean Cars",
      "origins.korean.innovation": "Value innovation",
      "origins.korean.tech": "Modern tech",
      "origins.korean.warranty": "Warranty strength",
      "origins.american": "American Cars",
      "origins.american.heritage": "Muscle heritage",
      "origins.american.torque": "Torque & utility",
      "origins.american.design": "Bold design",
      "origins.european": "European Cars",
      "origins.european.dynamics": "Precision dynamics",
      "origins.european.luxury": "Luxury craftsmanship",
      "origins.european.performance": "Performance pedigree",
      
      // CTA Section
      "cta.title": "Ready to Experience Premium Car Service?",
      "cta.subtitle": "Get in touch with our team for a free quote or schedule your service today",
      "cta.quote": "Request A Quote",
      "cta.whatsapp": "WhatsApp",
      
      // Footer
      "footer.about.title": "About Vigor Auto",
      "footer.about.desc": "Best car garage in Ras Al Khor Dubai offering expert auto repair, car service, and maintenance for all major brands.",
      "footer.services.title": "Service Focus",
      "footer.services.diagnostics": "Diagnostics & Electrical",
      "footer.services.performance": "Performance & Tuning",
      "footer.services.detailing": "Premium Detailing",
      "footer.services.maintenance": "Preventive Maintenance",
      "footer.services.suspension": "Suspension & Handling",
      "footer.contact.title": "Contact Info",
      "footer.location": "Ras Al Khor, Dubai, UAE",
      "footer.copyright": "© 2025 Vigor Auto Repair. All rights reserved.",
      
      // Contact Page
      "contact.title": "Visit Our Ras Al Khor Car Garage",
      "contact.subtitle": "Have a service question, want a maintenance plan, or need rapid diagnostic support? Our Ras Al Khor auto service centre is available 7 days a week serving Dubai, Nad Al Hamar, Al Awir & International City.",
      "contact.info.title": "Contact Information",
      "contact.info.subtitle": "Our team is ready to assist you with all your automotive needs.",
      "contact.location.title": "Our Location",
      "contact.email.title": "Email Us",
      "contact.phone.title": "Call Us",
      "contact.hours.title": "Working Hours",
      "contact.hours.value": "Mon - Sun: 8:00 AM - 8:00 PM",
      "contact.form.title": "Send Us a Message",
      "contact.form.subtitle": "Use the form below and we'll get back to you as soon as possible.",
      "contact.form.category": "Category",
      "contact.form.categoryPlaceholder": "Select...",
      "contact.form.name": "Full Name",
      "contact.form.namePlaceholder": "Your name",
      "contact.form.email": "Email Address",
      "contact.form.emailPlaceholder": "you@example.com",
      "contact.form.phone": "Phone Number",
      "contact.form.phonePlaceholder": "e.g. +971 56 ...",
      "contact.form.message": "Your Message",
      "contact.form.messagePlaceholder": "Tell us what you need help with...",
      "contact.form.required": "All fields marked * are required.",
      "contact.form.submit": "Send Message",
      "contact.form.submitting": "Sending…",
      "contact.form.success": "Success! Your message has been sent. We will be in touch shortly.",
      "contact.form.error": "We could not send your message right now. Please try WhatsApp or call us.",
      "contact.form.validation.name": "Name required",
      "contact.form.validation.email": "Email required",
      "contact.form.validation.emailInvalid": "Invalid email",
      "contact.form.validation.phone": "Phone required",
      "contact.form.validation.message": "Message required",
      "contact.map.title": "Find Us Here",
      "contact.map.openMaps": "Open in Google Maps",
      "contact.cta.title": "Ready to care for your car?",
      "contact.cta.subtitle": "Book full-service maintenance, precision repair, or premium detailing—one trusted destination.",
      "contact.cta.call": "Call Now",
      "contact.cta.email": "Email Us",
      "contact.badge": "Contact Us",
      "contact.categories.general": "General Inquiry",
      "contact.categories.service": "Service Booking",
      "contact.categories.detailing": "Detailing",
      "contact.categories.diagnostics": "Diagnostics",
      "contact.categories.other": "Other",
      
      // About Page
      "about.badge": "About Us",
      "about.title": "Ras Al Khor's Trusted Dealer-Alternative Car Garage",
      "about.subtitle": "Vigor Auto Garage was founded on a simple principle: provide Dubai's drivers with a trustworthy, high-quality, and transparent auto repair experience. We combine dealership-level expertise with the personal touch and affordability of an independent car garage in Ras Al Khor.",
      "about.story.title": "Our Story",
      "about.story.p1": "At Vigor Auto Garage, we understand that your vehicle is more than just a means of transportation—it's an essential part of your life. That's why we are committed to providing top-tier automotive services that enhance your vehicle's performance and longevity.",
      "about.story.p2": "Our state-of-the-art facility in Ras Al Khor is equipped with the latest diagnostic tools and staffed by certified technicians who are passionate about cars. We are not just mechanics; we are automotive enthusiasts dedicated to keeping your vehicle running at its best.",
      "about.values.title": "Core Values",
      "about.values.subtitle": "Our core values guide every interaction and every repair.",
      "about.values.quality": "Quality Workmanship",
      "about.values.quality.desc": "Precision diagnostics, premium parts, and careful execution on every repair.",
      "about.values.customer": "Customer Focus",
      "about.values.customer.desc": "Transparent communication and service options tailored to what you actually need.",
      "about.values.innovation": "Innovation & Excellence",
      "about.values.innovation.desc": "Modern tooling, continual training, and a mindset of constant improvement.",
      "about.values.integrity": "Integrity",
      "about.values.integrity.desc": "Honest recommendations that protect both safety and long‑term vehicle value.",
      "about.specialties.title": "Our Technical Specialties",
      "about.specialties.subtitle": "We service a wide range of vehicles, with deep expertise in the following areas:",
      "about.specialties.european": "European & German marques",
      "about.specialties.japanese": "Japanese performance & reliability platforms",
      "about.specialties.domestic": "Domestic vehicles & daily drivers",
      "about.specialties.detailing": "Detailing, interior restoration & cosmetic care",
      "about.specialties.mechanical": "Mechanical, electrical & body systems",
      
      // Common
      "common.readMore": "Read More",
      "common.learnMore": "Learn More",
      "common.bookNow": "Book Now",
      "common.callUs": "Call Us",
      "common.getQuote": "Get Quote",
      "common.viewAll": "View All",
      "common.loading": "Loading...",
      "common.free": "FREE",
      
      // Services Page
      "services.hero.badge": "Service",
      "services.hero.description": "Expert care for all makes and models",
      "services.overview": "Overview",
      "services.whatYouGet": "What You Get",
      "services.faq.title": "Frequently Asked Questions",
      "services.faq.q1": "How often should I service my car?",
      "services.faq.a1": "Most manufacturers recommend a minor service every 10,000-15,000 km and a major service every 30,000-45,000 km. However, this can vary based on your car's make, model, and age. We can provide a specific schedule based on your vehicle.",
      "services.faq.q2": "Do you use genuine parts?",
      "services.faq.a2": "We prioritize using OEM (Original Equipment Manufacturer) and high-quality aftermarket parts from reputable suppliers to ensure the best performance and longevity for your vehicle. We provide clear options so you can make an informed choice.",
      "services.faq.q3": "Can you service a car that is still under warranty?",
      "services.faq.a3": "Yes, we can. We follow manufacturer-specified procedures and use approved parts, ensuring your warranty remains valid. We provide all necessary documentation for your records.",
      "services.faq.q4": "What are the signs my brakes need checking?",
      "services.faq.a4": "Common signs include a squealing or grinding noise, a pulsating or spongy brake pedal, the car pulling to one side when braking, or the brake warning light illuminating on your dashboard. If you notice any of these, get your brakes inspected immediately.",
      "services.faq.q5": "How long does a typical service take?",
      "services.faq.a5": "A minor service usually takes 2-3 hours, while a major service can take 4-6 hours. Repairs for specific issues will vary. We always provide an estimated timeframe when you book your service and keep you updated on the progress.",
      
      // Individual Services
      "services.vehicleRepair": "Vehicle Repair & Maintenance",
      "services.vehicleRepair.desc": "End-to-end scheduled and corrective servicing preserving reliability, efficiency & lifecycle value.",
      "services.carScanning": "Car Scanning & Diagnostics",
      "services.carScanning.desc": "Advanced OBD, module interrogation & live data analysis to isolate faults accurately.",
      "services.majorMinor": "Major & Minor Service",
      "services.majorMinor.desc": "Structured interval services: fluids, filters, wear items, torque validation & health reporting.",
      "services.carAC": "Car AC Services",
      "services.carAC.desc": "Cooling performance recovery: leak detection, refrigerant optimization & cabin air quality.",
      "services.premiumOil": "Premium Oil Services",
      "services.premiumOil.desc": "High-spec lubricants & filter strategy aligned to driving profile & engine requirements.",
      "services.denting": "Car Denting & Painting",
      "services.denting.desc": "Panel correction, refinishing & OEM color-match blending for factory-level appearance.",
      "services.battery": "Car Battery Services",
      "services.battery.desc": "Load testing, intelligent replacements & terminal integrity for dependable starts.",
      "services.brakes": "Car Brakes Services",
      "services.brakes.desc": "Pad, rotor & hydraulic performance assessment ensuring confident, linear stopping.",
      "services.brakesSuspension": "Car Brakes & Suspension",
      "services.brakesSuspension.desc": "Integrated dynamics: suspension geometry, bushing, damping & braking synergy.",
      "services.engine": "Car Engine Repair",
      "services.engine.desc": "Mechanical restoration, sealing, timing & efficiency recovery for long-term durability.",
      "services.transmission": "Car Transmission Repair",
      "services.transmission.desc": "Automatic & manual driveline diagnosis, fluid service & component rebuild coordination.",
      "services.tyre": "Tyre Replacement",
      "services.tyre.desc": "Balanced fitment, tread advisory & alignment synergy for grip, safety & wear optimization.",
      
      // Request Quote Page
      "quote.badge": "Request A Quote",
      "quote.title": "Get Free Car Service Quote - Ras Al Khor",
      "quote.subtitle": "Provide your vehicle & service details and our Ras Al Khor car garage will respond with a transparent estimate. Complex diagnostic-dependent jobs may require an initial inspection at our workshop.",
      "quote.form.customerDetails": "Customer Details",
      "quote.form.fullName": "Full Name",
      "quote.form.phone": "Phone",
      "quote.form.email": "Email",
      "quote.form.preferredDate": "Preferred Date",
      "quote.form.vehicleDetails": "Vehicle Details",
      "quote.form.make": "Make",
      "quote.form.model": "Model",
      "quote.form.year": "Year",
      "quote.form.mileage": "Mileage (km)",
      "quote.form.serviceRequest": "Service Request",
      "quote.form.serviceNeeded": "Service Needed",
      "quote.form.notes": "Additional Notes",
      "quote.form.notesPlaceholder": "Describe issues, noises, symptoms or goals...",
      "quote.form.required": "Fields marked * are required. We respect your privacy.",
      "quote.form.submit": "Submit Request",
      "quote.form.submitting": "Submitting…",
      "quote.form.multipleServices": "You can select multiple services.",
      "quote.form.errorRequired": "Required",
      "quote.form.errorInvalid": "Invalid",
      "quote.form.success": "Success! Your request was received. Our team will respond shortly.",
      "quote.sidebar.whyTitle": "Why Details Matter",
      "quote.sidebar.whyText": "Accurate vehicle & condition info lets us provide a fair initial range without overestimating. If a deeper diagnostic is required, we'll advise transparently.",
      "quote.sidebar.benefit1": "Faster accurate estimates",
      "quote.sidebar.benefit2": "Prevents unnecessary part swapping",
      "quote.sidebar.benefit3": "Helps prioritize critical issues",
      "quote.sidebar.realTimeTitle": "Need Real-Time?",
      "quote.sidebar.realTimeText": "Send a quick photo, voice note or video walk-around on WhatsApp for rapid triage.",
      "quote.sidebar.openWhatsApp": "Open WhatsApp",
      "quote.whatsapp": "WhatsApp Instead",
      
      // Testimonials Page
      "testimonials.badge": "Testimonials",
      "testimonials.title": "What Our Ras Al Khor Clients Say",
      "testimonials.subtitle": "Real feedback reflecting our commitment to precision, transparency and long-term vehicle care.",
      "testimonials.writeReview": "Write a review",
      "testimonials.filterBy": "Filter by Service:",
      "testimonials.showing": "Showing",
      "testimonials.reviews": "reviews",
      "testimonials.verified": "Verified Customer",
      "testimonials.service": "Service",
      "testimonials.all": "All",
      
      // Blog Page
      "blog.badge": "Blog",
      "blog.title": "Car Service & Care Insights from Ras Al Khor",
      "blog.subtitle": "Actionable maintenance guidance, problem diagnostics and climate-specific optimization for vehicles in Dubai from our certified technicians at Vigor Auto Ras Al Khor.",
      "blog.readTime": "min read",
      "blog.published": "Published",
      
      // Offers Page
      "offers.badge": "Offers",
      "offers.title": "Car Service Promotions in Ras Al Khor Dubai",
      "offers.subtitle": "Strategic bundles and seasonal incentives crafted to maximize vehicle value, longevity and driving enjoyment at our Ras Al Khor car garage.",
      "offers.featured": "Featured Promotions",
      "offers.featuredDesc": "Each offer is capacity-managed—secure slots early for optimal turnaround and availability.",
      "offers.active": "Active",
      "offers.pending": "Pending / Refresh Soon",
      "offers.code": "Code",
      "offers.expires": "Expires in",
      "offers.expired": "Expired",
      "offers.days": "days",
      "offers.cta.title": "Ready to redeem an offer?",
      "offers.cta.subtitle": "Contact our advisory team—slots are dynamically allocated based on workload balancing and efficiency windows.",
      "offers.redeem": "Redeem via WhatsApp",
      
      // Individual Offers
      "offers.offer1.tag": "Promo",
      "offers.offer1.title": "FREE Computer Scan – 2 Months",
      "offers.offer1.desc": "Complimentary full system OBD & module scan for any qualifying visit. Ideal for tracking intermittent faults & early detection.",
      "offers.offer1.category": "Diagnostics",
      
      "offers.offer2.tag": "Bundle",
      "offers.offer2.title": "Oil Change + Free Multi-Point Items",
      "offers.offer2.desc": "Book an oil & filter change and get: free brake pad inspection, belt check, spark plug visual check, radiator water top-up, brake fluid level check, AC filter cleaning.",
      "offers.offer2.category": "Maintenance",
      
      "offers.offer3.tag": "Seasonal",
      "offers.offer3.title": "AC System Service Package",
      "offers.offer3.desc": "Pressure test, leak detect, refrigerant optimization & cabin filter health check bundled.",
      "offers.offer3.category": "Maintenance",
      
      "offers.offer4.tag": "New",
      "offers.offer4.title": "Brake & Fluid Safety Bundle – 10% Off",
      "offers.offer4.desc": "Pads + brake fluid flush + caliper slide service. Restore stopping confidence.",
      "offers.offer4.category": "Mechanical",
      
      "offers.offer5.tag": "Performance",
      "offers.offer5.title": "ECU Baseline + Diagnostics Scan",
      "offers.offer5.desc": "Data log, readiness review & fault mapping to plan smarter performance upgrades.",
      "offers.offer5.category": "Performance",
    }
  },
  ar: {
    translation: {
      // Navigation
      "nav.home": "الرئيسية",
      "nav.services": "الخدمات",
      "nav.about": "من نحن",
      "nav.offers": "العروض",
      "nav.testimonials": "آراء العملاء",
      "nav.blog": "المدونة",
      "nav.contact": "اتصل بنا",
      "nav.requestQuote": "طلب عرض سعر",
      "nav.whatsapp": "واتساب",
      "nav.getQuote": "احصل على عرض سعر",
      "nav.rasAlKhor": "زر ورشة رأس الخور",
      "nav.rasAlKhorShort": "رأس الخور",
      "nav.chatWhatsApp": "دردش عبر واتساب",
      
      // Hero Section
      "hero.title.main": "ورشة دبي الممتازة لكل سيارة",
      "hero.title.sub": "معقولة وموثوقة",
      "hero.subtitle": "خدمة سيارات متخصصة في رأس الخور لجميع السيارات الأوروبية واليابانية والكورية والأمريكية مع فنيين معتمدين",
      "hero.cta.quote": "طلب عرض سعر",
      "hero.cta.whatsapp": "واتساب",
      
      // Offers Cards
      "offers.diagnostics": "فحص كمبيوتر مجاني",
      "offers.oilChange": "تغيير زيت + عناصر مجانية",
      "offers.pickup": "خدمة التوصيل مجاناً",
      "offers.brands": "جميع الماركات الرئيسية",
      
      // Free Inspection
      "inspection.badge": "عرض لفترة محدودة",
      "inspection.title": "فحص شامل مجاني للسيارة في رأس الخور",
      "inspection.description": "احصل على فحص متعدد النقاط بدون تكلفة في ورشتنا برأس الخور يشمل الفرامل والسيور والشمعات ومستوى ماء الرادياتير ومستوى سائل الفرامل وتنظيف فلتر المكيف. مثالي لسائقي دبي قبل تغيير الموسم أو السفر لمسافات طويلة.",
      "inspection.cta.book": "احجز الفحص المجاني",
      "inspection.cta.offers": "عرض جميع العروض",
      "inspection.items.brake": "فحص تيل الفرامل",
      "inspection.items.belt": "فحص السيور",
      "inspection.items.spark": "حالة البواجي",
      "inspection.items.radiator": "تعبئة ماء الرادياتير",
      "inspection.items.brakeFluid": "مستوى زيت الفرامل",
      "inspection.items.acFilter": "تنظيف فلتر المكيف",
      
      // Services Section
      "services.title": "خدمات سيارات شاملة في رأس الخور دبي",
      "services.subtitle": "من الصيانة الدورية إلى إصلاحات الأنظمة المعقدة، فنيونا المعتمدون في ورشتنا برأس الخور يقدمون خدمة بجودة الوكالة مع عناية وشفافية الورشة المستقلة. نخدم مجتمع دبي للسيارات الأوروبية واليابانية والكورية والأمريكية.",
      
      // Why Choose Us
      "whyChoose.title": "لماذا تختار فيجور أوتو؟",
      "whyChoose.expertise": "خبرة +15 عام",
      "whyChoose.expertise.desc": "فنيون متمرسون يستخدمون بيانات OEM والتشخيص الحديث",
      "whyChoose.turnaround": "إنجاز سريع",
      "whyChoose.turnaround.desc": "سير عمل مبسط وتشخيص دقيق من المرة الأولى",
      "whyChoose.transparent": "تقديرات شفافة",
      "whyChoose.transparent.desc": "تسعير عادل متوافق مع معايير العمل والأسعار المرجعية",
      "whyChoose.quality": "قطع غيار عالية الجودة",
      "whyChoose.quality.desc": "قطع OEM / Tier-1 للموثوقية والأداء",
      
      // Vehicle Origins
      "origins.title": "نخدم جميع أنواع السيارات",
      "origins.subtitle": "من المنصات اليابانية الدقيقة إلى البناء الأمريكي القوي والابتكار الكوري المتقدم والهندسة الأوروبية الدقيقة - فريقنا متعدد التخصصات يدعمها جميعاً.",
      "origins.japanese": "السيارات اليابانية",
      "origins.japanese.reliability": "موثوقية",
      "origins.japanese.engineering": "هندسة متقنة",
      "origins.japanese.performance": "أداء متوازن",
      "origins.korean": "السيارات الكورية",
      "origins.korean.innovation": "ابتكار القيمة",
      "origins.korean.tech": "تقنية حديثة",
      "origins.korean.warranty": "قوة الضمان",
      "origins.american": "السيارات الأمريكية",
      "origins.american.heritage": "تراث العضلات",
      "origins.american.torque": "عزم وقوة",
      "origins.american.design": "تصميم جريء",
      "origins.european": "السيارات الأوروبية",
      "origins.european.dynamics": "ديناميكية دقيقة",
      "origins.european.luxury": "حرفية فاخرة",
      "origins.european.performance": "نسب أداء",
      
      // CTA Section
      "cta.title": "جاهز لتجربة خدمة سيارات ممتازة؟",
      "cta.subtitle": "تواصل مع فريقنا للحصول على عرض سعر مجاني أو جدولة خدمتك اليوم",
      "cta.quote": "طلب عرض سعر",
      "cta.whatsapp": "واتساب",
      
      // Footer
      "footer.about.title": "عن فيجور أوتو",
      "footer.about.desc": "أفضل ورشة سيارات في رأس الخور دبي تقدم إصلاح وصيانة سيارات متخصصة لجميع الماركات الرئيسية.",
      "footer.services.title": "تركيز الخدمة",
      "footer.services.diagnostics": "التشخيص والكهرباء",
      "footer.services.performance": "الأداء والتعديل",
      "footer.services.detailing": "التفصيل المميز",
      "footer.services.maintenance": "الصيانة الوقائية",
      "footer.services.suspension": "التعليق والتحكم",
      "footer.contact.title": "معلومات الاتصال",
      "footer.location": "رأس الخور، دبي، الإمارات",
      "footer.copyright": "© 2025 فيجور أوتو للإصلاح. جميع الحقوق محفوظة.",
      
      // Contact Page
      "contact.title": "زر ورشتنا في رأس الخور",
      "contact.subtitle": "هل لديك سؤال عن الخدمة، أو تريد خطة صيانة، أو تحتاج دعم تشخيصي سريع؟ مركز خدمة السيارات في رأس الخور متاح 7 أيام في الأسبوع لخدمة دبي وناد الحمر والعوير والمدينة العالمية.",
      "contact.info.title": "معلومات الاتصال",
      "contact.info.subtitle": "فريقنا جاهز لمساعدتك في جميع احتياجاتك للسيارات.",
      "contact.location.title": "موقعنا",
      "contact.email.title": "راسلنا",
      "contact.phone.title": "اتصل بنا",
      "contact.hours.title": "ساعات العمل",
      "contact.hours.value": "7 أيام في الأسبوع مع جدولة مرنة",
      "contact.form.title": "أرسل لنا رسالة",
      "contact.form.subtitle": "استخدم النموذج أدناه وسنعاود الاتصال بك في أقرب وقت ممكن.",
      "contact.form.category": "الفئة",
      "contact.form.categoryPlaceholder": "اختر...",
      "contact.form.name": "الاسم الكامل",
      "contact.form.namePlaceholder": "اسمك",
      "contact.form.email": "البريد الإلكتروني",
      "contact.form.emailPlaceholder": "you@example.com",
      "contact.form.phone": "رقم الهاتف",
      "contact.form.phonePlaceholder": "مثال: +971 56 ...",
      "contact.form.message": "رسالتك",
      "contact.form.messagePlaceholder": "أخبرنا بما تحتاج مساعدة فيه...",
      "contact.form.required": "جميع الحقول المميزة بـ * مطلوبة.",
      "contact.form.submit": "إرسال الرسالة",
      "contact.form.submitting": "جاري الإرسال...",
      "contact.form.success": "نجح! تم إرسال رسالتك. سنتواصل معك قريباً.",
      "contact.form.error": "لم نتمكن من إرسال رسالتك الآن. يرجى المحاولة عبر واتساب أو الاتصال بنا.",
      "contact.form.validation.name": "الاسم مطلوب",
      "contact.form.validation.email": "البريد الإلكتروني مطلوب",
      "contact.form.validation.emailInvalid": "بريد إلكتروني غير صالح",
      "contact.form.validation.phone": "رقم الهاتف مطلوب",
      "contact.form.validation.message": "الرسالة مطلوبة",
      "contact.map.title": "اعثر علينا هنا",
      "contact.map.openMaps": "فتح في خرائط جوجل",
      "contact.cta.title": "مستعد للعناية بسيارتك؟",
      "contact.cta.subtitle": "احجز صيانة كاملة أو إصلاح دقيق أو تفصيل متميز - وجهة واحدة موثوقة.",
      "contact.cta.call": "اتصل الآن",
      "contact.cta.email": "راسلنا",
      "contact.badge": "اتصل بنا",
      "contact.categories.general": "استفسار عام",
      "contact.categories.service": "حجز خدمة",
      "contact.categories.detailing": "تفصيل",
      "contact.categories.diagnostics": "تشخيص",
      "contact.categories.other": "أخرى",
      
      // About Page
      "about.badge": "من نحن",
      "about.title": "ورشة السيارات البديلة الموثوقة في رأس الخور",
      "about.subtitle": "تأسست ورشة فيجور أوتو على مبدأ بسيط: تزويد سائقي دبي بتجربة إصلاح سيارات موثوقة وعالية الجودة وشفافة. نجمع بين خبرة مستوى الوكالة واللمسة الشخصية والأسعار المعقولة لورشة سيارات مستقلة في رأس الخور.",
      "about.story.title": "قصتنا",
      "about.story.p1": "في ورشة فيجور أوتو، ندرك أن سيارتك أكثر من مجرد وسيلة نقل - إنها جزء أساسي من حياتك. لهذا السبب نحن ملتزمون بتقديم خدمات سيارات من الدرجة الأولى تعزز أداء سيارتك وعمرها الافتراضي.",
      "about.story.p2": "منشأتنا الحديثة في رأس الخور مجهزة بأحدث أدوات التشخيص ويعمل بها فنيون معتمدون متحمسون للسيارات. نحن لسنا مجرد ميكانيكيين؛ نحن عشاق سيارات مكرسون للحفاظ على تشغيل سيارتك في أفضل حالاتها.",
      "about.values.title": "قيمنا الأساسية",
      "about.values.subtitle": "قيمنا الأساسية توجه كل تفاعل وكل إصلاح.",
      "about.values.quality": "جودة الصنعة",
      "about.values.quality.desc": "تشخيص دقيق وقطع غيار متميزة وتنفيذ دقيق في كل إصلاح.",
      "about.values.customer": "التركيز على العملاء",
      "about.values.customer.desc": "تواصل شفاف وخيارات خدمة مصممة لما تحتاجه فعلاً.",
      "about.values.innovation": "الابتكار والتميز",
      "about.values.innovation.desc": "أدوات حديثة، تدريب مستمر، وعقلية التحسين المستمر.",
      "about.values.integrity": "النزاهة",
      "about.values.integrity.desc": "توصيات صادقة تحمي السلامة وقيمة السيارة على المدى الطويل.",
      "about.specialties.title": "تخصصاتنا التقنية",
      "about.specialties.subtitle": "نخدم مجموعة واسعة من السيارات، مع خبرة عميقة في المجالات التالية:",
      "about.specialties.european": "الماركات الأوروبية والألمانية",
      "about.specialties.japanese": "منصات الأداء والموثوقية اليابانية",
      "about.specialties.domestic": "المركبات المحلية والسيارات اليومية",
      "about.specialties.detailing": "التفصيل، استعادة الداخلية والعناية التجميلية",
      "about.specialties.mechanical": "الأنظمة الميكانيكية والكهربائية والجسم",
      
      // Common
      "common.readMore": "اقرأ المزيد",
      "common.learnMore": "تعرف على المزيد",
      "common.bookNow": "احجز الآن",
      "common.callUs": "اتصل بنا",
      "common.getQuote": "احصل على عرض سعر",
      "common.viewAll": "عرض الكل",
      "common.loading": "جاري التحميل...",
      "common.free": "مجاني",
      
      // Services Page
      "services.hero.badge": "خدمة",
      "services.hero.description": "عناية متخصصة لجميع الماركات والموديلات",
      "services.overview": "نظرة عامة",
      "services.whatYouGet": "ما تحصل عليه",
      "services.faq.title": "الأسئلة الشائعة",
      "services.faq.q1": "كم مرة يجب أن أقوم بصيانة سيارتي؟",
      "services.faq.a1": "توصي معظم الشركات المصنعة بصيانة صغيرة كل 10,000-15,000 كم وصيانة كبيرة كل 30,000-45,000 كم. ومع ذلك، يمكن أن يختلف هذا بناءً على ماركة سيارتك وطرازها وعمرها. يمكننا تقديم جدول محدد بناءً على سيارتك.",
      "services.faq.q2": "هل تستخدمون قطع غيار أصلية؟",
      "services.faq.a2": "نعطي الأولوية لاستخدام قطع OEM (الشركة المصنعة الأصلية) وقطع ما بعد البيع عالية الجودة من موردين موثوقين لضمان أفضل أداء وعمر لسيارتك. نوفر خيارات واضحة حتى تتمكن من اتخاذ قرار مستنير.",
      "services.faq.q3": "هل يمكنكم صيانة سيارة لا تزال تحت الضمان؟",
      "services.faq.a3": "نعم، يمكننا ذلك. نتبع الإجراءات المحددة من قبل الشركة المصنعة ونستخدم قطع غيار معتمدة، مما يضمن بقاء الضمان الخاص بك ساري المفعول. نوفر جميع الوثائق اللازمة لسجلاتك.",
      "services.faq.q4": "ما هي علامات حاجة الفرامل للفحص؟",
      "services.faq.a4": "تشمل العلامات الشائعة صوت صرير أو طحن، دواسة فرامل نابضة أو إسفنجية، انحراف السيارة إلى جانب واحد عند الفرملة، أو إضاءة ضوء تحذير الفرامل على لوحة القيادة. إذا لاحظت أيًا من هذه العلامات، افحص الفرامل على الفور.",
      "services.faq.q5": "كم من الوقت تستغرق الصيانة العادية؟",
      "services.faq.a5": "عادةً ما تستغرق الصيانة الصغيرة 2-3 ساعات، بينما يمكن أن تستغرق الصيانة الكبيرة 4-6 ساعات. ستختلف الإصلاحات لمشاكل محددة. نقدم دائمًا إطارًا زمنيًا تقديريًا عند حجز خدمتك ونبقيك على اطلاع بالتقدم.",
      
      // Individual Services
      "services.vehicleRepair": "إصلاح وصيانة السيارات",
      "services.vehicleRepair.desc": "خدمة شاملة مجدولة وتصحيحية للحفاظ على الموثوقية والكفاءة وقيمة دورة الحياة.",
      "services.carScanning": "فحص وتشخيص السيارة",
      "services.carScanning.desc": "تحليل متقدم OBD واستجواب الوحدات وتحليل البيانات الحية لعزل الأعطال بدقة.",
      "services.majorMinor": "الصيانة الكبرى والصغرى",
      "services.majorMinor.desc": "خدمات الفترات المنظمة: السوائل، الفلاتر، قطع الاستهلاك، التحقق من العزم وتقارير الصحة.",
      "services.carAC": "خدمات تكييف السيارة",
      "services.carAC.desc": "استعادة أداء التبريد: كشف التسرب، تحسين المبرد وجودة هواء المقصورة.",
      "services.premiumOil": "خدمات الزيت الممتازة",
      "services.premiumOil.desc": "زيوت تشحيم عالية المواصفات واستراتيجية فلتر متوافقة مع نمط القيادة ومتطلبات المحرك.",
      "services.denting": "دعس ودهان السيارة",
      "services.denting.desc": "تصحيح اللوحات، إعادة الطلاء ومزج ألوان OEM لمظهر مصنعي.",
      "services.battery": "خدمات بطارية السيارة",
      "services.battery.desc": "اختبار الحمل، الاستبدال الذكي وسلامة الأطراف لبدء تشغيل موثوق.",
      "services.brakes": "خدمات فرامل السيارة",
      "services.brakes.desc": "تقييم أداء الوسادات والأقراص والهيدروليك لضمان توقف واثق وخطي.",
      "services.brakesSuspension": "الفرامل والتعليق",
      "services.brakesSuspension.desc": "ديناميكية متكاملة: هندسة التعليق، البطانة، التخميد وتآزر الكبح.",
      "services.engine": "إصلاح محرك السيارة",
      "services.engine.desc": "استعادة ميكانيكية، إغلاق، توقيت واستعادة الكفاءة لمتانة طويلة الأجل.",
      "services.transmission": "إصلاح ناقل الحركة",
      "services.transmission.desc": "تشخيص ناقل الحركة الأوتوماتيكي واليدوي، خدمة السوائل وتنسيق إعادة بناء المكونات.",
      "services.tyre": "استبدال الإطارات",
      "services.tyre.desc": "تركيب متوازن، استشارة المداس وتآزر المحاذاة للقبضة والسلامة وتحسين الاستهلاك.",
      
      // Request Quote Page
      "quote.badge": "طلب عرض سعر",
      "quote.title": "احصل على عرض سعر مجاني لخدمة السيارة - رأس الخور",
      "quote.subtitle": "قدم تفاصيل سيارتك والخدمة وستستجيب ورشة السيارات لدينا في رأس الخور بتقدير شفاف. قد تتطلب الوظائف المعتمدة على التشخيص المعقد فحصًا أوليًا في ورشتنا.",
      "quote.form.customerDetails": "تفاصيل العميل",
      "quote.form.fullName": "الاسم الكامل",
      "quote.form.phone": "رقم الهاتف",
      "quote.form.email": "البريد الإلكتروني",
      "quote.form.preferredDate": "التاريخ المفضل",
      "quote.form.vehicleDetails": "تفاصيل السيارة",
      "quote.form.make": "الماركة",
      "quote.form.model": "الموديل",
      "quote.form.year": "السنة",
      "quote.form.mileage": "المسافة المقطوعة (كم)",
      "quote.form.serviceRequest": "طلب الخدمة",
      "quote.form.serviceNeeded": "الخدمة المطلوبة",
      "quote.form.notes": "ملاحظات إضافية",
      "quote.form.notesPlaceholder": "صف المشاكل، الأصوات، الأعراض أو الأهداف...",
      "quote.form.required": "الحقول المميزة بـ * مطلوبة. نحن نحترم خصوصيتك.",
      "quote.form.submit": "إرسال الطلب",
      "quote.form.submitting": "جاري الإرسال…",
      "quote.form.multipleServices": "يمكنك اختيار خدمات متعددة.",
      "quote.form.errorRequired": "مطلوب",
      "quote.form.errorInvalid": "غير صالح",
      "quote.form.success": "نجاح! تم استلام طلبك. سيرد فريقنا قريباً.",
      "quote.sidebar.whyTitle": "لماذا التفاصيل مهمة",
      "quote.sidebar.whyText": "معلومات دقيقة عن السيارة والحالة تتيح لنا تقديم نطاق أولي عادل دون مبالغة في التقدير. إذا كان هناك حاجة لتشخيص أعمق، سننصح بشفافية.",
      "quote.sidebar.benefit1": "تقديرات دقيقة أسرع",
      "quote.sidebar.benefit2": "يمنع استبدال القطع غير الضرورية",
      "quote.sidebar.benefit3": "يساعد في تحديد أولويات القضايا الحرجة",
      "quote.sidebar.realTimeTitle": "هل تحتاج استجابة فورية؟",
      "quote.sidebar.realTimeText": "أرسل صورة سريعة أو ملاحظة صوتية أو فيديو على واتساب للفرز السريع.",
      "quote.sidebar.openWhatsApp": "فتح واتساب",
      "quote.whatsapp": "واتساب بدلاً من ذلك",
      
      // Testimonials Page
      "testimonials.badge": "آراء العملاء",
      "testimonials.title": "ما يقوله عملاؤنا في رأس الخور",
      "testimonials.subtitle": "ملاحظات حقيقية تعكس التزامنا بالدقة والشفافية والعناية طويلة الأمد بالمركبات.",
      "testimonials.writeReview": "اكتب تقييماً",
      "testimonials.filterBy": "تصفية حسب الخدمة:",
      "testimonials.showing": "عرض",
      "testimonials.reviews": "تقييمات",
      "testimonials.verified": "عميل موثق",
      "testimonials.service": "الخدمة",
      "testimonials.all": "الكل",
      
      // Blog Page
      "blog.badge": "مدونة",
      "blog.title": "رؤى خدمة ورعاية السيارات من رأس الخور",
      "blog.subtitle": "إرشادات صيانة قابلة للتنفيذ، تشخيص المشاكل والتحسين الخاص بالمناخ للمركبات في دبي من الفنيين المعتمدين لدينا في فيجور أوتو رأس الخور.",
      "blog.readTime": "دقيقة قراءة",
      "blog.published": "نُشر في",
      
      // Offers Page
      "offers.badge": "عروض",
      "offers.title": "عروض خدمة السيارات في رأس الخور دبي",
      "offers.subtitle": "باقات استراتيجية وحوافز موسمية مصممة لتعظيم قيمة السيارة وطول العمر ومتعة القيادة في ورشة السيارات لدينا في رأس الخور.",
      "offers.featured": "العروض المميزة",
      "offers.featuredDesc": "كل عرض يتم إدارة سعته - احجز المواعيد مبكرًا للحصول على أفضل تسليم وتوفر.",
      "offers.active": "نشط",
      "offers.pending": "قيد الانتظار / التحديث قريبًا",
      "offers.code": "الكود",
      "offers.expires": "ينتهي في",
      "offers.expired": "منتهي الصلاحية",
      "offers.days": "أيام",
      "offers.cta.title": "جاهز لاسترداد عرض؟",
      "offers.cta.subtitle": "اتصل بفريق الاستشارات لدينا - يتم تخصيص الفتحات ديناميكيًا بناءً على موازنة عبء العمل ونوافذ الكفاءة.",
      "offers.redeem": "استرداد عبر واتساب",
      
      // Individual Offers
      "offers.offer1.tag": "عرض",
      "offers.offer1.title": "فحص كمبيوتر مجاني - شهرين",
      "offers.offer1.desc": "فحص كامل مجاني لنظام OBD والوحدات لأي زيارة مؤهلة. مثالي لتتبع الأعطال المتقطعة والكشف المبكر.",
      "offers.offer1.category": "التشخيص",
      
      "offers.offer2.tag": "باقة",
      "offers.offer2.title": "تغيير زيت + عناصر مجانية متعددة",
      "offers.offer2.desc": "احجز تغيير زيت وفلتر واحصل على: فحص مجاني لوسادات الفرامل، فحص الحزام، فحص بصري لشمعات الإشعال، تعبئة ماء الرادياتير، فحص مستوى سائل الفرامل، تنظيف فلتر التكييف.",
      "offers.offer2.category": "الصيانة",
      
      "offers.offer3.tag": "موسمي",
      "offers.offer3.title": "باقة خدمة نظام التكييف",
      "offers.offer3.desc": "اختبار الضغط، كشف التسرب، تحسين غاز التبريد وفحص صحة فلتر المقصورة مجمعة.",
      "offers.offer3.category": "الصيانة",
      
      "offers.offer4.tag": "جديد",
      "offers.offer4.title": "باقة أمان الفرامل والسوائل - خصم 10٪",
      "offers.offer4.desc": "وسادات + تنظيف سائل الفرامل + خدمة انزلاق الفرجار. استعد ثقة التوقف.",
      "offers.offer4.category": "ميكانيكي",
      
      "offers.offer5.tag": "أداء",
      "offers.offer5.title": "خط أساس ECU + فحص التشخيص",
      "offers.offer5.desc": "سجل البيانات، مراجعة الجاهزية ورسم الأعطال للتخطيط لترقيات أداء أذكى.",
      "offers.offer5.category": "الأداء",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
